import { Grid, pn, useElementBreakpoints } from "@compass/core";
import { DatePicker, Select, SubmitButton } from "components";
import { StaffServiceFilter as StaffServiceFilterModel, StaffServiceFilterResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ServiceFilter = (props: {
  filter: StaffServiceFilterModel;
  setFilter: (value: StaffServiceFilterModel) => void;
}) => {
  const { breakpointsRef, xSmallFieldBreakpoints, smallFieldBreakpoints } = useElementBreakpoints();
  const [filter, setFilter] = useState<StaffServiceFilterModel>(props.filter);
  const [resource, setResource] = useState<StaffServiceFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.staffServices.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  useEffect(() => {
    if (filter) {
      props.setFilter(filter);
    }
  }, [filter]);

  const serviceTypeField = () => {
    const propertyName = pn<StaffServiceFilterModel>("serviceTypeIds");
    const property = properties.find((x) => x.propertyName === propertyName);
    return (
      <Select
        modelProperty={property}
        value={resource.serviceTypes?.find((x) => filter?.serviceTypeIds?.includes(x.id))}
        options={resource.serviceTypes}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) => {
          setFilter(
            produce((draft) => {
              draft.serviceTypeIds = value ? [value.id] : undefined;
            })
          );
        }}
        size="small"
        label="Service Types"
      />
    );
  };

  const dateFromField = () => {
    const propertyName = pn<StaffServiceFilterModel>("dateFrom");
    const property = properties.find((x) => x.propertyName === propertyName);
    return (
      <DatePicker
        modelProperty={property}
        value={filter.dateFrom}
        onChange={(value) => {
          setFilter(
            produce((draft) => {
              draft.dateFrom = value;
            })
          );
        }}
        size="small"
      />
    );
  };

  const dateToField = () => {
    const propertyName = pn<StaffServiceFilterModel>("dateTo");
    const property = properties.find((x) => x.propertyName === propertyName);
    return (
      <DatePicker
        modelProperty={property}
        value={filter.dateTo}
        onChange={(value) => {
          setFilter(
            produce((draft) => {
              draft.dateTo = value;
            })
          );
        }}
        size="small"
      />
    );
  };

  const clearFilter = () => {
    const clearedFilter: StaffServiceFilterModel = {
      ...props.filter,
      serviceTypeIds: undefined,
      dateFrom: undefined,
      dateTo: undefined,
    };
    setFilter(clearedFilter);
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm" alignItems="center" style={{ width: "100%" }}>
      <Grid item xs={smallFieldBreakpoints}>
        {serviceTypeField()}
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        {dateFromField()}
      </Grid>
      <Grid item xs={xSmallFieldBreakpoints}>
        {dateToField()}
      </Grid>
      {(filter.serviceTypeIds?.length || filter.dateFrom || filter.dateTo) && (
        <Grid item alignItems="center">
          <SubmitButton 
            label="Clear" 
            variant="outlined" 
            onClick={clearFilter} 
          />
        </Grid>
      )}
    </Grid>
  );
};